<div class="sectionbar">
  <app-opfoelgning-nav></app-opfoelgning-nav>
</div>
<div class="topbar">
  <h1>Opfølgninger på serviceordrer</h1>
  <div class="topbar__actions">
    @if (opfoelgninger.length > 0) {
      <small>
        Viser {{ opfoelgninger.length }}
        <span>af {{ rowCount }}</span>
        opfoelgninger
      </small>
    }
    @if (isAdmin) {
      <mat-slide-toggle
        class="margin--left-l"
        [(ngModel)]="showForAllUsers"
        color="primary"
        (change)="onShowForAllUsersToggle()"
        >
        Vis for alle brugere
      </mat-slide-toggle>
    }
  </div>
</div>
<div class="page__content subscriptions subscriptions--list">
  <table
    mat-table
    matSort
    [dataSource]="dataSource"
    (matSortChange)="sortData($event)"
    [matSortDisabled]="isLoading"
    [matSortActive]="orderBy"
    [matSortDirection]="orderDir"
    class="mat-elevation-z0 has-notifications has-notifications--x2"
    >
    <ng-container matColumnDef="opfoelgning">
      <th mat-header-cell *matHeaderCellDef class="hidden-cell"></th>
      <td mat-cell *matCellDef="let opfoelgning" class="hidden-cell hidden-cell--pinned">
        <button type="button" class="btn-icon opacity-hover" (click)="opfoelgningClick($event, opfoelgning)" [disabled]="!canWrite">
          <app-opfoelgning-button [opfoelgningList]="opfoelgning.serviceordre.opfoelgningList"></app-opfoelgning-button>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="parked">
      <th mat-header-cell class="hidden-cell" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let opfoelgning" class="hidden-cell hidden-cell--pinned">
        <button type="button" class="btn-icon" (click)="opfoelgningClick($event, opfoelgning)">
          @if (opfoelgning.serviceordre.serviceordreStateEnum == serviceordreStatusEnum.Parked) {
            <mat-icon
              svgIcon="park"
              matTooltip="Parkeret"
            ></mat-icon>
          }
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="serviceordre.produkt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let opfoelgning">
        <mat-icon
          [svgIcon]="getProductIcon(opfoelgning.serviceordre)"
          [matTooltip]="getProductIcon(opfoelgning.serviceordre) | titlecase"
        ></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let opfoelgning">
        {{ opfoelgning.serviceordre.serviceordreStateUserText }}
      </td>
    </ng-container>
    <ng-container matColumnDef="serviceordre.serviceordreno">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ordrenr.</th>
      <td mat-cell *matCellDef="let opfoelgning">{{ opfoelgning.serviceordre.serviceordreNo }}</td>
    </ng-container>
    <ng-container matColumnDef="serviceordre.okKundeAftaleNr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Aftalenr.</th>
      <td mat-cell *matCellDef="let opfoelgning">{{ opfoelgning.serviceordre.okKundeAftalenr }}</td>
    </ng-container>
    <ng-container matColumnDef="serviceordre.serviceordreType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Opgave</th>
      <td mat-cell *matCellDef="let opfoelgning">{{ opfoelgning.serviceordre.opgaveDisplayText }}</td>
    </ng-container>
    <ng-container matColumnDef="serviceordre.partner.name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Partner</th>
      <td mat-cell *matCellDef="let opfoelgning">{{ opfoelgning.serviceordre.partner.name }}</td>
    </ng-container>
    <ng-container matColumnDef="modifiedOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Senest ændret</th>
      <td mat-cell *matCellDef="let opfoelgning">
        <app-date-user [date]="opfoelgning.modifiedOn" [user]="opfoelgning.modifiedBy"></app-date-user>
      </td>
    </ng-container>
    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Oprettet</th>
      <td mat-cell *matCellDef="let opfoelgning">
        <app-date-user [date]="opfoelgning.createdOn" [user]="opfoelgning.createdBy"></app-date-user>
      </td>
    </ng-container>
    <ng-container matColumnDef="priority">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Prioritet</th>
      <td mat-cell *matCellDef="let opfoelgning">
        @if (opfoelgning.priority === 1) {
          <div class="coin coin--red" matTooltip="Høj prioritet"></div>
        }
        @if (opfoelgning.priority === 2) {
          <div class="coin coin--orange" matTooltip="Middel prioritet"></div>
        }
        @if (opfoelgning.priority === 3) {
          <div class="coin coin--grey" matTooltip="Lav prioritet"></div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="deadline">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Deadline</th>
      <td mat-cell *matCellDef="let opfoelgning">
        @if (opfoelgning.deadline) {
          <div [class]="deadline(opfoelgning)" matTooltip="Deadline d. {{ opfoelgning.deadline | date: 'shortDate' }}">
            <span>d. {{ opfoelgning.deadline | date: 'shortDate' }}</span>
          </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Bruger</th>
      <td mat-cell *matCellDef="let opfoelgning">
        {{ opfoelgning.user }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (dblclick)="onRowDblClick(row)"
      [class.active]="globalActiveRowID == row.serviceordre.id"
      [appScrollToRow]="prevRow"
      [rowId]="row.serviceordre.serviceordreNo"
      (rowActive)="highLight($event)"
    ></tr>
  </table>
  @if (page < pageCount) {
    <div class="align-center margin-top-x2">
      <button type="button" mat-raised-button color="accent" class="btn-trans mat-elevation-z0" (click)="more()" [disabled]="this.isLoading">
        Vis flere opfølgninger
      </button>
    </div>
  }
</div>
